import { ADMIN_ROLES, Role } from "../utils/helpers/role";

export type NavRoleRequirement = {
    /** User needs at least one of these roles. Empty/undefined = all authenticated users. */
    roles?: readonly string[];
};

export const HUB_EMPTY_MESSAGE =
    "No shortcuts are available for your account in this area. Use the sidebar or contact an Administrator.";

export const SETTINGS_NON_ADMIN_MESSAGE =
    "No organisation settings are available for your account.";

export function hasAnyRole(userRoles: string[], required?: readonly string[]): boolean {
    if (!required || required.length === 0) {
        return true;
    }
    return required.some((role) => userRoles.includes(role));
}

export function isAdminUser(userRoles: string[]): boolean {
    return hasAnyRole(userRoles, ADMIN_ROLES);
}

export function isNavItemVisible(item: NavRoleRequirement, userRoles: string[]): boolean {
    return hasAnyRole(userRoles, item.roles);
}

export function filterNavItemsByRoles<T extends NavRoleRequirement>(
    items: readonly T[],
    userRoles: string[]
): T[] {
    return items.filter((item) => isNavItemVisible(item, userRoles));
}

export function getUserRoleNames(roles: ReadonlyArray<{ name: string }>): string[] {
    return roles.map((r) => r.name);
}

export { ADMIN_ROLES, Role };
